<div class="header" *ngIf="label || headerControl.length"
     [ngClass]="{'content-hidden': hideContent}">
    <div class="header-control before" *ngIf="headerControl.length"
        #before [ngClass]="{'empty': before.children.length === 0}">
        <ng-content select="fui-content-layout-header-control[slot=before]"></ng-content>
    </div>
    <div class="header-label">
        <div class="header-label-title">
            {{label | translate: i18nParams}}
        </div>
    </div>
    <div class="header-control after" *ngIf="headerControl.length"
        #after [ngClass]="{'empty': after.children.length === 0}">
        <ng-content select="fui-content-layout-header-control[slot=after]"></ng-content>
    </div>
</div>
<div class="main" [hidden]="hideContent">
    <ng-content></ng-content>
</div>

